// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-navigation-drawer[data-v-2f25567e]{z-index:100!important}.v-navigation-drawer.theme--light[data-v-2f25567e]{background-color:var(--v-background-light-base)!important;opacity:.8}.v-navigation-drawer.theme--dark[data-v-2f25567e]{background-color:var(--v-background-dark-base)!important;opacity:.8}.v-list-item .v-list-item__icon[data-v-2f25567e]{width:30px}", ""]);
// Exports
module.exports = exports;
